var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ReferenciaObraService } from '../../../services/referenciaObraService.ts';
import { showConfirmDialog } from '../../utils/confirmDialog';
export var CatalogoReferenciasObrasMixin = {
    data: function () {
        return {
            referenciasObras: [],
            showModal: false,
            modoEdicion: false,
            cargando: false,
            guardando: false,
            formulario: {
                idReferenciaObra: null,
                nombre: '',
            },
        };
    },
    mounted: function () {
        this.cargarReferenciasObras();
    },
    methods: {
        cargarReferenciasObras: function () {
            return __awaiter(this, void 0, Promise, function () {
                var _a, error_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.cargando = true;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            _a = this;
                            return [4 /*yield*/, ReferenciaObraService.getAll()];
                        case 2:
                            _a.referenciasObras = _b.sent();
                            return [3 /*break*/, 5];
                        case 3:
                            error_1 = _b.sent();
                            console.error('Error al cargar referencias de obras:', error_1);
                            this.$toast.error('Error al cargar las referencias de obras');
                            return [3 /*break*/, 5];
                        case 4:
                            this.cargando = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        editarReferencia: function (referencia) {
            this.modoEdicion = true;
            this.formulario = __assign({}, referencia);
            this.$bvModal.show('modal-referencia-obra');
        },
        guardarReferencia: function () {
            return __awaiter(this, void 0, Promise, function () {
                var updatedReferencia, index, newReferencia, error_2, axiosError;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.guardando = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 6, 7, 8]);
                            if (!this.modoEdicion) return [3 /*break*/, 3];
                            return [4 /*yield*/, ReferenciaObraService.update(this.formulario.idReferenciaObra, this.formulario)];
                        case 2:
                            updatedReferencia = _a.sent();
                            index = this.referenciasObras.findIndex(function (r) { return r.idReferenciaObra === _this.formulario.idReferenciaObra; });
                            if (index !== -1) {
                                this.referenciasObras[index] = updatedReferencia;
                            }
                            this.$toast.success('Referencia de obra actualizada correctamente');
                            return [3 /*break*/, 5];
                        case 3: return [4 /*yield*/, ReferenciaObraService.create(this.formulario)];
                        case 4:
                            newReferencia = _a.sent();
                            this.referenciasObras.push(newReferencia);
                            this.$toast.success('Referencia de obra creada correctamente');
                            _a.label = 5;
                        case 5:
                            this.limpiarFormulario();
                            this.$bvModal.hide('modal-referencia-obra');
                            return [3 /*break*/, 8];
                        case 6:
                            error_2 = _a.sent();
                            console.error('Error al guardar referencia de obra:', error_2);
                            axiosError = error_2;
                            if (axiosError.response && axiosError.response.status === 400) {
                                this.$toast.error('Datos inválidos. Verifique la información ingresada.');
                            }
                            else {
                                this.$toast.error('Error al guardar la referencia de obra');
                            }
                            return [3 /*break*/, 8];
                        case 7:
                            this.guardando = false;
                            return [7 /*endfinally*/];
                        case 8: return [2 /*return*/];
                    }
                });
            });
        },
        eliminarReferencia: function (id) {
            return __awaiter(this, void 0, Promise, function () {
                var referencia, nombreReferencia, confirmed, result, error_3, error_4, axiosError;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            referencia = this.referenciasObras.find(function (r) { return r.idReferenciaObra === id; });
                            nombreReferencia = (referencia === null || referencia === void 0 ? void 0 : referencia.nombre) || 'esta referencia de obra';
                            confirmed = false;
                            if (!(this.$swal && typeof this.$swal === 'function')) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, showConfirmDialog(this.$swal, {
                                    title: '¿Eliminar referencia de obra?',
                                    itemName: nombreReferencia,
                                    itemType: 'referencia de obra'
                                })];
                        case 2:
                            result = _a.sent();
                            confirmed = result.value;
                            return [3 /*break*/, 4];
                        case 3:
                            error_3 = _a.sent();
                            console.warn('Error con SweetAlert2, usando confirm nativo:', error_3);
                            confirmed = confirm("\u00BFEst\u00E1 seguro de que desea eliminar \"".concat(nombreReferencia, "\"?"));
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            confirmed = confirm("\u00BFEst\u00E1 seguro de que desea eliminar \"".concat(nombreReferencia, "\"?"));
                            _a.label = 6;
                        case 6:
                            if (!confirmed) return [3 /*break*/, 10];
                            _a.label = 7;
                        case 7:
                            _a.trys.push([7, 9, , 10]);
                            return [4 /*yield*/, ReferenciaObraService.delete(id)];
                        case 8:
                            _a.sent();
                            this.referenciasObras = this.referenciasObras.filter(function (r) { return r.idReferenciaObra !== id; });
                            this.$toast.success("Referencia de obra \"".concat(nombreReferencia, "\" eliminada correctamente"));
                            return [3 /*break*/, 10];
                        case 9:
                            error_4 = _a.sent();
                            console.error('Error al eliminar referencia de obra:', error_4);
                            axiosError = error_4;
                            if (axiosError.response && axiosError.response.status === 404) {
                                this.$toast.error('La referencia de obra no existe');
                            }
                            else if (axiosError.response && axiosError.response.status === 409) {
                                this.$toast.error('No se puede eliminar la referencia de obra porque está siendo utilizada');
                            }
                            else {
                                this.$toast.error('Error al eliminar la referencia de obra');
                            }
                            return [3 /*break*/, 10];
                        case 10: return [2 /*return*/];
                    }
                });
            });
        },
        limpiarFormulario: function () {
            this.formulario = {
                idReferenciaObra: null,
                nombre: '',
            };
            this.modoEdicion = false;
        },
    },
};
